webpackJsonp([35783957827783],{

/***/ 118:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeJsIso = __webpack_require__(145);
	
	var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSwipe = function (_Component) {
	  _inherits(ReactSwipe, _Component);
	
	  function ReactSwipe() {
	    _classCallCheck(this, ReactSwipe);
	
	    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
	  }
	
	  _createClass(ReactSwipe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var swipeOptions = this.props.swipeOptions;
	
	
	      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          childCount = _props.childCount,
	          swipeOptions = _props.swipeOptions;
	
	
	      if (prevProps.childCount !== childCount) {
	        this.swipe.kill();
	        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.swipe.kill();
	      this.swipe = void 0;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.swipe.next();
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.swipe.prev();
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      var _swipe;
	
	      (_swipe = this.swipe).slide.apply(_swipe, arguments);
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.swipe.getPos();
	    }
	  }, {
	    key: 'getNumSlides',
	    value: function getNumSlides() {
	      return this.swipe.getNumSlides();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            return _this2.container = container;
	          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
	        _react2.default.createElement(
	          'div',
	          { style: style.wrapper },
	          _react2.default.Children.map(children, function (child) {
	            if (!child) {
	              return null;
	            }
	
	            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;
	
	            return _react2.default.cloneElement(child, { style: childStyle });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReactSwipe;
	}(_react.Component);
	
	ReactSwipe.propTypes = {
	  swipeOptions: _propTypes2.default.shape({
	    startSlide: _propTypes2.default.number,
	    speed: _propTypes2.default.number,
	    auto: _propTypes2.default.number,
	    continuous: _propTypes2.default.bool,
	    disableScroll: _propTypes2.default.bool,
	    stopPropagation: _propTypes2.default.bool,
	    swiping: _propTypes2.default.func,
	    callback: _propTypes2.default.func,
	    transitionEnd: _propTypes2.default.func
	  }),
	  style: _propTypes2.default.shape({
	    container: _propTypes2.default.object,
	    wrapper: _propTypes2.default.object,
	    child: _propTypes2.default.object
	  }),
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  childCount: _propTypes2.default.number
	};
	ReactSwipe.defaultProps = {
	  swipeOptions: {},
	  style: {
	    container: {
	      overflow: 'hidden',
	      visibility: 'hidden',
	      position: 'relative'
	    },
	
	    wrapper: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    child: {
	      float: 'left',
	      width: '100%',
	      position: 'relative',
	      transitionProperty: 'transform'
	    }
	  },
	  className: '',
	  childCount: 0
	};
	exports.default = ReactSwipe;
	module.exports = exports['default'];


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(6);
	var DetectPassiveEvents = __webpack_require__(118).default;
	
	function getInitialState() {
	  return {
	    x: null,
	    y: null,
	    swiping: false,
	    start: 0
	  };
	}
	
	function getMovingPosition(e) {
	  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	function getPosition(e) {
	  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	
	function rotateByAngle(pos, angle) {
	  if (angle === 0) {
	    return pos;
	  }
	
	  var x = pos.x,
	      y = pos.y;
	
	
	  var angleInRadians = Math.PI / 180 * angle;
	  var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
	  var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
	  return { x: rotatedX, y: rotatedY };
	}
	
	function calculatePos(e, state) {
	  var _rotateByAngle = rotateByAngle(getMovingPosition(e), state.rotationAngle),
	      x = _rotateByAngle.x,
	      y = _rotateByAngle.y;
	
	  var deltaX = state.x - x;
	  var deltaY = state.y - y;
	
	  var absX = Math.abs(deltaX);
	  var absY = Math.abs(deltaY);
	
	  var time = Date.now() - state.start;
	  var velocity = Math.sqrt(absX * absX + absY * absY) / time;
	
	  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
	}
	
	var Swipeable = function (_React$Component) {
	  _inherits(Swipeable, _React$Component);
	
	  function Swipeable(props, context) {
	    _classCallCheck(this, Swipeable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.swipeable = getInitialState();
	
	    _this.eventStart = _this.eventStart.bind(_this);
	    _this.eventMove = _this.eventMove.bind(_this);
	    _this.eventEnd = _this.eventEnd.bind(_this);
	    _this.mouseDown = _this.mouseDown.bind(_this);
	    _this.mouseMove = _this.mouseMove.bind(_this);
	    _this.mouseUp = _this.mouseUp.bind(_this);
	    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
	    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
	    _this.elementRef = _this.elementRef.bind(_this);
	    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
	    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
	
	    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
	    return _this;
	  }
	
	  Swipeable.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.disabled !== this.props.disabled) {
	      this.cleanupMouseListeners();
	
	      this.swipeable = getInitialState();
	    }
	
	    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
	      this.cleanupTouchmoveEvent();
	    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cleanupMouseListeners();
	  };
	
	  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
	    document.addEventListener('mousemove', this.mouseMove);
	    document.addEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
	    document.removeEventListener('mousemove', this.mouseMove);
	    document.removeEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.mouseDown = function mouseDown(e) {
	    if (!this.props.trackMouse || e.type !== 'mousedown') {
	      return;
	    }
	
	    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);
	
	    this.setupMouseListeners();
	
	    this.eventStart(e);
	  };
	
	  Swipeable.prototype.mouseMove = function mouseMove(e) {
	    this.eventMove(e);
	  };
	
	  Swipeable.prototype.mouseUp = function mouseUp(e) {
	    this.cleanupMouseListeners();
	    this.eventEnd(e);
	  };
	
	  Swipeable.prototype.eventStart = function eventStart(e) {
	    if (e.touches && e.touches.length > 1) return;
	
	    var rotationAngle = this.props.rotationAngle;
	
	    var _rotateByAngle2 = rotateByAngle(getPosition(e), rotationAngle),
	        x = _rotateByAngle2.x,
	        y = _rotateByAngle2.y;
	
	    if (this.props.stopPropagation) e.stopPropagation();
	
	    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false, rotationAngle: rotationAngle };
	  };
	
	  Swipeable.prototype.eventMove = function eventMove(e) {
	    var _props = this.props,
	        stopPropagation = _props.stopPropagation,
	        delta = _props.delta,
	        onSwiping = _props.onSwiping,
	        onSwiped = _props.onSwiped,
	        onSwipingLeft = _props.onSwipingLeft,
	        onSwipedLeft = _props.onSwipedLeft,
	        onSwipingRight = _props.onSwipingRight,
	        onSwipedRight = _props.onSwipedRight,
	        onSwipingUp = _props.onSwipingUp,
	        onSwipedUp = _props.onSwipedUp,
	        onSwipingDown = _props.onSwipingDown,
	        onSwipedDown = _props.onSwipedDown,
	        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;
	
	
	    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
	      return;
	    }
	
	    var pos = calculatePos(e, this.swipeable);
	
	    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;
	
	    if (stopPropagation) e.stopPropagation();
	
	    if (onSwiping) {
	      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
	    }
	
	    var cancelablePageSwipe = false;
	    if (onSwiping || onSwiped) {
	      cancelablePageSwipe = true;
	    }
	
	    if (pos.absX > pos.absY) {
	      if (pos.deltaX > 0) {
	        if (onSwipingLeft || onSwipedLeft) {
	          onSwipingLeft && onSwipingLeft(e, pos.absX);
	          cancelablePageSwipe = true;
	        }
	      } else if (onSwipingRight || onSwipedRight) {
	        onSwipingRight && onSwipingRight(e, pos.absX);
	        cancelablePageSwipe = true;
	      }
	    } else if (pos.deltaY > 0) {
	      if (onSwipingUp || onSwipedUp) {
	        onSwipingUp && onSwipingUp(e, pos.absY);
	        cancelablePageSwipe = true;
	      }
	    } else if (onSwipingDown || onSwipedDown) {
	      onSwipingDown && onSwipingDown(e, pos.absY);
	      cancelablePageSwipe = true;
	    }
	
	    this.swipeable.swiping = true;
	
	    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
	  };
	
	  Swipeable.prototype.eventEnd = function eventEnd(e) {
	    var _props2 = this.props,
	        stopPropagation = _props2.stopPropagation,
	        flickThreshold = _props2.flickThreshold,
	        onSwiped = _props2.onSwiped,
	        onSwipedLeft = _props2.onSwipedLeft,
	        onSwipedRight = _props2.onSwipedRight,
	        onSwipedUp = _props2.onSwipedUp,
	        onSwipedDown = _props2.onSwipedDown,
	        onTap = _props2.onTap;
	
	
	    if (this.swipeable.swiping) {
	      var pos = calculatePos(e, this.swipeable);
	
	      if (stopPropagation) e.stopPropagation();
	
	      var isFlick = pos.velocity > flickThreshold;
	
	      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);
	
	      if (pos.absX > pos.absY) {
	        if (pos.deltaX > 0) {
	          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
	        } else {
	          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
	        }
	      } else if (pos.deltaY > 0) {
	        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
	      } else {
	        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
	      }
	    } else {
	      onTap && onTap(e);
	    }
	
	    this.swipeable = getInitialState();
	  };
	
	  Swipeable.prototype.elementRef = function elementRef(element) {
	    this.element = element;
	    this.props.innerRef && this.props.innerRef(element);
	  };
	
	  Swipeable.prototype.render = function render() {
	    var newProps = _extends({}, this.props);
	    if (!this.props.disabled) {
	      newProps.onTouchStart = this.eventStart;
	
	      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
	        newProps.onTouchMove = this.eventMove;
	      }
	
	      newProps.onTouchEnd = this.eventEnd;
	      newProps.onMouseDown = this.mouseDown;
	    }
	
	    newProps.ref = this.elementRef;
	
	    delete newProps.onSwiped;
	    delete newProps.onSwiping;
	    delete newProps.onSwipingUp;
	    delete newProps.onSwipingRight;
	    delete newProps.onSwipingDown;
	    delete newProps.onSwipingLeft;
	    delete newProps.onSwipedUp;
	    delete newProps.onSwipedRight;
	    delete newProps.onSwipedDown;
	    delete newProps.onSwipedLeft;
	    delete newProps.onTap;
	    delete newProps.flickThreshold;
	    delete newProps.delta;
	    delete newProps.preventDefaultTouchmoveEvent;
	    delete newProps.stopPropagation;
	    delete newProps.nodeName;
	    delete newProps.children;
	    delete newProps.trackMouse;
	    delete newProps.disabled;
	    delete newProps.innerRef;
	    delete newProps.rotationAngle;
	
	    return React.createElement(this.props.nodeName, newProps, this.props.children);
	  };
	
	  return Swipeable;
	}(React.Component);
	
	Swipeable.propTypes = {
	  onSwiped: PropTypes.func,
	  onSwiping: PropTypes.func,
	  onSwipingUp: PropTypes.func,
	  onSwipingRight: PropTypes.func,
	  onSwipingDown: PropTypes.func,
	  onSwipingLeft: PropTypes.func,
	  onSwipedUp: PropTypes.func,
	  onSwipedRight: PropTypes.func,
	  onSwipedDown: PropTypes.func,
	  onSwipedLeft: PropTypes.func,
	  onTap: PropTypes.func,
	  flickThreshold: PropTypes.number,
	  delta: PropTypes.number,
	  preventDefaultTouchmoveEvent: PropTypes.bool,
	  stopPropagation: PropTypes.bool,
	  nodeName: PropTypes.string,
	  trackMouse: PropTypes.bool,
	  disabled: PropTypes.bool,
	  innerRef: PropTypes.func,
	  children: PropTypes.node,
	  rotationAngle: PropTypes.number
	};
	
	Swipeable.defaultProps = {
	  flickThreshold: 0.6,
	  delta: 10,
	  preventDefaultTouchmoveEvent: false,
	  stopPropagation: false,
	  nodeName: 'div',
	  disabled: false,
	  rotationAngle: 0
	};
	
	module.exports = Swipeable;

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	/*
	 * Swipe 2.0.0
	 * Brad Birdsall
	 * https://github.com/thebird/Swipe
	 * Copyright 2013-2015, MIT License
	 *
	 */
	
	(function(root, factory) {
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = factory();
	  } else {
	    root.Swipe = factory();
	  }
	})(this, function() {
	  'use strict';
	
	  return function Swipe(container, options) {
	    // utilities
	    var noop = function() {}; // simple no operation function
	    var offloadFn = function(fn) {
	      setTimeout(fn || noop, 0);
	    }; // offload a functions execution
	
	    // check browser capabilities
	    var browser = {
	      addEventListener: !!window.addEventListener,
	      touch:
	        'ontouchstart' in window ||
	        (window.DocumentTouch && document instanceof window.DocumentTouch),
	      transitions: (function(temp) {
	        var props = [
	          'transitionProperty',
	          'WebkitTransition',
	          'MozTransition',
	          'OTransition',
	          'msTransition'
	        ];
	        for (var i in props)
	          if (temp.style[props[i]] !== undefined) return true;
	        return false;
	      })(document.createElement('swipe'))
	    };
	
	    // quit if no root element
	    if (!container) return;
	    var element = container.children[0];
	    var slides, slidePos, width, length;
	    options = options || {};
	    var index = parseInt(options.startSlide, 10) || 0;
	    var speed = options.speed || 300;
	    var widthOfSiblingSlidePreview =
	      parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
	    var continuous = (options.continuous =
	      options.continuous !== undefined ? options.continuous : true);
	
	    function setup() {
	      // cache slides
	      slides = element.children;
	      length = slides.length;
	
	      // set continuous to false if only one slide
	      continuous = slides.length < 2 ? false : options.continuous;
	
	      // create an array to store current positions of each slide
	      slidePos = new Array(slides.length);
	
	      // determine width of each slide
	      width =
	        Math.round(
	          container.getBoundingClientRect().width || container.offsetWidth
	        ) -
	        widthOfSiblingSlidePreview * 2;
	
	      element.style.width = slides.length * width + 'px';
	
	      // stack elements
	      var pos = slides.length;
	      while (pos--) {
	        var slide = slides[pos];
	
	        slide.style.width = width + 'px';
	        slide.setAttribute('data-index', pos);
	
	        if (browser.transitions) {
	          slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
	          move(pos, index > pos ? -width : index < pos ? width : 0, 0);
	        }
	      }
	
	      // reposition elements before and after index
	      if (continuous && browser.transitions) {
	        move(circle(index - 1), -width, 0);
	        move(circle(index + 1), width, 0);
	      }
	
	      if (!browser.transitions)
	        element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';
	
	      container.style.visibility = 'visible';
	    }
	
	    function prev() {
	      if (continuous) slide(index - 1);
	      else if (index) slide(index - 1);
	    }
	
	    function next() {
	      if (continuous) slide(index + 1);
	      else if (index < slides.length - 1) slide(index + 1);
	    }
	
	    function circle(index) {
	      // a simple positive modulo using slides.length
	      return (slides.length + (index % slides.length)) % slides.length;
	    }
	
	    function slide(to, slideSpeed) {
	      // do nothing if already on requested slide
	      if (index == to) return;
	
	      if (browser.transitions) {
	        var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward
	
	        // get the actual position of the slide
	        if (continuous) {
	          var natural_direction = direction;
	          direction = -slidePos[circle(to)] / width;
	
	          // if going forward but to < index, use to = slides.length + to
	          // if going backward but to > index, use to = -slides.length + to
	          if (direction !== natural_direction)
	            to = -direction * slides.length + to;
	        }
	
	        var diff = Math.abs(index - to) - 1;
	
	        // move all the slides between index and to in the right direction
	        while (diff--)
	          move(
	            circle((to > index ? to : index) - diff - 1),
	            width * direction,
	            0
	          );
	
	        to = circle(to);
	
	        move(index, width * direction, slideSpeed || speed);
	        move(to, 0, slideSpeed || speed);
	
	        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
	      } else {
	        to = circle(to);
	        animate(index * -width, to * -width, slideSpeed || speed);
	        //no fallback for a circular continuous if the browser does not accept transitions
	      }
	
	      index = to;
	      offloadFn(options.callback && options.callback(index, slides[index]));
	    }
	
	    function move(index, dist, speed) {
	      translate(index, dist, speed);
	      slidePos[index] = dist;
	    }
	
	    function translate(index, dist, speed) {
	      var slide = slides[index];
	      var style = slide && slide.style;
	
	      if (!style) return;
	
	      style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
	        speed + 'ms';
	
	      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
	      style.msTransform = style.MozTransform = style.OTransform =
	        'translateX(' + dist + 'px)';
	    }
	
	    function animate(from, to, speed) {
	      // if not an animation, just reposition
	      if (!speed) {
	        element.style.left = to + 'px';
	        return;
	      }
	
	      var start = +new Date();
	
	      var timer = setInterval(function() {
	        var timeElap = +new Date() - start;
	
	        if (timeElap > speed) {
	          element.style.left = to + 'px';
	
	          if (delay) begin();
	
	          options.transitionEnd &&
	            options.transitionEnd.call(event, index, slides[index]);
	
	          clearInterval(timer);
	          return;
	        }
	
	        element.style.left =
	          (to - from) * (Math.floor((timeElap / speed) * 100) / 100) +
	          from +
	          'px';
	      }, 4);
	    }
	
	    // setup auto slideshow
	    var delay = options.auto || 0;
	    var interval;
	
	    function begin() {
	      clearTimeout(interval);
	      interval = setTimeout(next, delay);
	    }
	
	    function stop() {
	      delay = 0;
	      clearTimeout(interval);
	    }
	
	    // setup initial vars
	    var start = {};
	    var delta = {};
	    var isScrolling;
	
	    // setup event capturing
	    var events = {
	      handleEvent: function(event) {
	        switch (event.type) {
	          case 'touchstart':
	            this.start(event);
	            break;
	          case 'touchmove':
	            this.move(event);
	            break;
	          case 'touchend':
	            offloadFn(this.end(event));
	            break;
	          case 'webkitTransitionEnd':
	          case 'msTransitionEnd':
	          case 'oTransitionEnd':
	          case 'otransitionend':
	          case 'transitionend':
	            offloadFn(this.transitionEnd(event));
	            break;
	          case 'resize':
	            offloadFn(setup);
	            break;
	        }
	
	        if (options.stopPropagation) event.stopPropagation();
	      },
	      start: function(event) {
	        var touches = event.touches[0];
	
	        // measure start values
	        start = {
	          // get initial touch coords
	          x: touches.pageX,
	          y: touches.pageY,
	
	          // store time to determine touch duration
	          time: +new Date()
	        };
	
	        // used for testing first move event
	        isScrolling = undefined;
	
	        // reset delta and end measurements
	        delta = {};
	
	        // attach touchmove and touchend listeners
	        element.addEventListener('touchmove', this, false);
	        element.addEventListener('touchend', this, false);
	      },
	      move: function(event) {
	        // ensure swiping with one touch and not pinching
	        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
	          return;
	
	        if (options.disableScroll) return;
	
	        var touches = event.touches[0];
	
	        // measure change in x and y
	        delta = {
	          x: touches.pageX - start.x,
	          y: touches.pageY - start.y
	        };
	
	        // determine if scrolling test has run - one time test
	        if (typeof isScrolling == 'undefined') {
	          isScrolling = !!(
	            isScrolling || Math.abs(delta.x) < Math.abs(delta.y)
	          );
	        }
	
	        // if user is not trying to scroll vertically
	        if (!isScrolling) {
	          // prevent native scrolling
	          event.preventDefault();
	
	          // stop slideshow
	          stop();
	
	          // increase resistance if first or last slide
	          if (continuous) {
	            // we don't add resistance at the end
	
	            translate(
	              circle(index - 1),
	              delta.x + slidePos[circle(index - 1)],
	              0
	            );
	            translate(index, delta.x + slidePos[index], 0);
	            translate(
	              circle(index + 1),
	              delta.x + slidePos[circle(index + 1)],
	              0
	            );
	          } else {
	            delta.x =
	              delta.x /
	              ((!index && delta.x > 0) || // if first slide and sliding left
	              (index == slides.length - 1 && // or if last slide and sliding right
	                delta.x < 0) // and if sliding at all
	                ? Math.abs(delta.x) / width + 1 // determine resistance level
	                : 1); // no resistance if false
	
	            // translate 1:1
	            translate(index - 1, delta.x + slidePos[index - 1], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(index + 1, delta.x + slidePos[index + 1], 0);
	          }
	          options.swiping && options.swiping(-delta.x / width);
	        }
	      },
	      end: function(event) {
	        // measure duration
	        var duration = +new Date() - start.time;
	
	        // determine if slide attempt triggers next/prev slide
	        var isValidSlide =
	          (Number(duration) < 250 && // if slide duration is less than 250ms
	            Math.abs(delta.x) > 20) || // and if slide amt is greater than 20px
	          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width
	
	        // determine if slide attempt is past start and end
	        var isPastBounds =
	          (!index && delta.x > 0) || // if first slide and slide amt is greater than 0
	          (index == slides.length - 1 && delta.x < 0); // or if last slide and slide amt is less than 0
	
	        if (continuous) isPastBounds = false;
	
	        // determine direction of swipe (true:right, false:left)
	        var direction = delta.x < 0;
	
	        // if not scrolling vertically
	        if (!isScrolling) {
	          if (isValidSlide && !isPastBounds) {
	            if (direction) {
	              if (continuous) {
	                // we need to get the next in this direction in place
	
	                move(circle(index - 1), -width, 0);
	                move(circle(index + 2), width, 0);
	              } else {
	                move(index - 1, -width, 0);
	              }
	
	              move(index, slidePos[index] - width, speed);
	              move(
	                circle(index + 1),
	                slidePos[circle(index + 1)] - width,
	                speed
	              );
	              index = circle(index + 1);
	            } else {
	              if (continuous) {
	                // we need to get the next in this direction in place
	
	                move(circle(index + 1), width, 0);
	                move(circle(index - 2), -width, 0);
	              } else {
	                move(index + 1, width, 0);
	              }
	
	              move(index, slidePos[index] + width, speed);
	              move(
	                circle(index - 1),
	                slidePos[circle(index - 1)] + width,
	                speed
	              );
	              index = circle(index - 1);
	            }
	
	            options.callback && options.callback(index, slides[index]);
	          } else {
	            if (continuous) {
	              move(circle(index - 1), -width, speed);
	              move(index, 0, speed);
	              move(circle(index + 1), width, speed);
	            } else {
	              move(index - 1, -width, speed);
	              move(index, 0, speed);
	              move(index + 1, width, speed);
	            }
	          }
	        }
	
	        // kill touchmove and touchend event listeners until touchstart called again
	        element.removeEventListener('touchmove', events, false);
	        element.removeEventListener('touchend', events, false);
	        element.removeEventListener('touchforcechange', function() {}, false);
	      },
	      transitionEnd: function(event) {
	        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
	          if (delay) begin();
	
	          options.transitionEnd &&
	            options.transitionEnd.call(event, index, slides[index]);
	        }
	      }
	    };
	
	    // trigger setup
	    setup();
	
	    // start auto slideshow if applicable
	    if (delay) begin();
	
	    // add event listeners
	    if (browser.addEventListener) {
	      // set touchstart event on element
	      if (browser.touch) {
	        element.addEventListener('touchstart', events, false);
	        element.addEventListener('touchforcechange', function() {}, false);
	      }
	
	      if (browser.transitions) {
	        element.addEventListener('webkitTransitionEnd', events, false);
	        element.addEventListener('msTransitionEnd', events, false);
	        element.addEventListener('oTransitionEnd', events, false);
	        element.addEventListener('otransitionend', events, false);
	        element.addEventListener('transitionend', events, false);
	      }
	
	      // set resize event on window
	      window.addEventListener('resize', events, false);
	    } else {
	      window.onresize = function() {
	        setup();
	      }; // to play nice with old IE
	    }
	
	    // expose the Swipe API
	    return {
	      setup: function() {
	        setup();
	      },
	      slide: function(to, speed) {
	        // cancel slideshow
	        stop();
	
	        slide(to, speed);
	      },
	      prev: function() {
	        // cancel slideshow
	        stop();
	
	        prev();
	      },
	      next: function() {
	        // cancel slideshow
	        stop();
	
	        next();
	      },
	      stop: function() {
	        // cancel slideshow
	        stop();
	      },
	      getPos: function() {
	        // return current index position
	        return index;
	      },
	      getNumSlides: function() {
	        // return total number of slides
	        return length;
	      },
	      kill: function() {
	        // cancel slideshow
	        stop();
	
	        // reset element
	        element.style.width = '';
	        element.style.left = '';
	
	        // reset slides
	        var pos = slides.length;
	        while (pos--) {
	          var slide = slides[pos];
	          slide.style.width = '';
	          slide.style.left = '';
	
	          if (browser.transitions) translate(pos, 0, 0);
	        }
	
	        // removed event listeners
	        if (browser.addEventListener) {
	          // remove current event listeners
	          element.removeEventListener('touchstart', events, false);
	          element.removeEventListener('webkitTransitionEnd', events, false);
	          element.removeEventListener('msTransitionEnd', events, false);
	          element.removeEventListener('oTransitionEnd', events, false);
	          element.removeEventListener('otransitionend', events, false);
	          element.removeEventListener('transitionend', events, false);
	          window.removeEventListener('resize', events, false);
	        } else {
	          window.onresize = null;
	        }
	      }
	    };
	  };
	});


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSwipe = __webpack_require__(143);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _carousel = __webpack_require__(91);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _Davos_logo = __webpack_require__(12);
	
	var _Davos_logo2 = _interopRequireDefault(_Davos_logo);
	
	var _Davos_slogan = __webpack_require__(14);
	
	var _Davos_slogan2 = _interopRequireDefault(_Davos_slogan);
	
	var _facebook = __webpack_require__(15);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(17);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _instagram = __webpack_require__(16);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _Landing_Illustration = __webpack_require__(31);
	
	var _Landing_Illustration2 = _interopRequireDefault(_Landing_Illustration);
	
	var _Landing_Illustration3 = __webpack_require__(60);
	
	var _Landing_Illustration4 = _interopRequireDefault(_Landing_Illustration3);
	
	var _Landing_Illustration5 = __webpack_require__(61);
	
	var _Landing_Illustration6 = _interopRequireDefault(_Landing_Illustration5);
	
	var _builder_laptop = __webpack_require__(65);
	
	var _builder_laptop2 = _interopRequireDefault(_builder_laptop);
	
	var _Donor_Macbook = __webpack_require__(59);
	
	var _Donor_Macbook2 = _interopRequireDefault(_Donor_Macbook);
	
	var _Stats_laptop = __webpack_require__(62);
	
	var _Stats_laptop2 = _interopRequireDefault(_Stats_laptop);
	
	var _Stats_laptop_b = __webpack_require__(63);
	
	var _Stats_laptop_b2 = _interopRequireDefault(_Stats_laptop_b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoSection = function (_Component) {
	  _inherits(InfoSection, _Component);
	
	  function InfoSection(props) {
	    _classCallCheck(this, InfoSection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      featuredItem: 'design'
	    };
	
	    _this.updateState = _this.updateState.bind(_this);
	    return _this;
	  }
	
	  InfoSection.prototype.updateState = function updateState(state) {
	    this.setState({
	      featuredItem: state
	    });
	  };
	
	  InfoSection.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.featuredItem === 'design') {
	      return _react2.default.createElement(
	        "div",
	        { className: "static-height-desktop" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden md:hidden" },
	          _react2.default.createElement(
	            "div",
	            { className: "flex featured-box", style: { marginTop: "-260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	              _react2.default.createElement(
	                "div",
	                { className: "my-8", style: { height: "250px" } },
	                _react2.default.createElement("img", { src: _Landing_Illustration2.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64", style: { top: "-200px", left: "25%" } }),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                  "\"No more countless hours trying to set up a donation form that looks like our website\""
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "text-white bg-teal px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "capitalize" },
	                  "Donation campaign builder"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Quickly design your campaign using our modern templates. Decide on the fonts, colour, images, content and gift ranges that best suit your needs."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Want to personalize even further or create your own template? You are always in control with our advanced settings."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-2/3 md:w-2/5" },
	              _react2.default.createElement("img", { src: _builder_laptop2.default, className: "mt-18 mb-8 relative donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "flex flex-wrap flex-auto self-center" },
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-teal" }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.updateState("dashboard");
	                    } }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.updateState("profile");
	                    } })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "w-64 md:hidden" },
	                  _react2.default.createElement(
	                    "button",
	                    { className: "flex-none w-2/3 ml-16 text-purple border border-purple text font-bold py-2 px-8 rounded-full capitalize mt-8 mb-4 focus:outline-none focus:shadow-outline float-right", onClick: function onClick() {
	                        return _this2.updateState("dashboard");
	                      } },
	                    "Next"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "text-purple font-bold text-right w-full leading-loose" },
	                    "Understand how your ",
	                    _react2.default.createElement("br", null),
	                    " campaigns are performing"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_carousel2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center mx-auto px-4 py-8 md:p-8 w-full lg:hidden md:hidden mt-8" },
	          _react2.default.createElement(
	            "div",
	            { className: "lg:hidden md:hidden" },
	            _react2.default.createElement("img", { src: _builder_laptop2.default, className: "mt-18 mb-8 relative donor-profile-laptop", style: { height: "350px", maxWidth: "500px", left: "40" } }),
	            _react2.default.createElement("img", { src: _Landing_Illustration2.default, className: "w-48 mt-18 mb-8 relative donor-profile-illustration", style: { top: "-160px", left: "0px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: "my-8" },
	              _react2.default.createElement(
	                "p",
	                { className: "text-purple-light text-xl w-3/4 mx-4 leading-normal relative text-right float-right", style: { top: "-200px" } },
	                "\"No more countless hours trying to set up a donation form that looks like our website!\""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text-white mobile-teal px-8 mx-auto py-12 text-center relative  lg:hidden md:hidden", style: { top: "-160px" } },
	          _react2.default.createElement(
	            "h3",
	            { className: "capitalize pt-8" },
	            "Donation campaign builder"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg" },
	            "Quickly design your campaign using our modern templates. Decide on the fonts, colour, images, content and gift ranges that best suit your needs."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg" },
	            "Want to personalize even further or create your own template? You are always in control with our advanced settings."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center mx-auto px-4 py-8 md:p-8 w-full lg:hidden md:hidden mt-8 relative" },
	          _react2.default.createElement(
	            "div",
	            { className: "lg:hidden md:hidden" },
	            _react2.default.createElement("img", { src: _Stats_laptop2.default, className: "mt-18 mb-8 absolute donor-profile-laptop", style: { top: "-250px", height: "350px", maxWidth: "500px", left: "0px" } }),
	            _react2.default.createElement("img", { src: _Stats_laptop_b2.default, className: "mt-18 mb-8 absolute donor-profile-laptop", style: { top: "30px", height: "200px", maxWidth: "500px", left: "75" } }),
	            _react2.default.createElement("img", { src: _Landing_Illustration4.default, className: "w-48 mt-18 mb-8 relative donor-profile-illustration", style: { top: "130px", left: "80px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: "mt-8 pt-1 text-center mx-auto w-3/4" },
	              _react2.default.createElement(
	                "p",
	                { className: "text-purple-light text-xl mx-4 leading-normal relative text-center mt-12 pt-12" },
	                "\"The beauty of it is that's all in one place!\""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text-white mobile-orange px-8 mx-auto py-12 text-center relative lg:hidden md:hidden", style: {} },
	          _react2.default.createElement(
	            "h3",
	            { className: "capitalize mt-8" },
	            "Charity Dashboard"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg" },
	            "Get a clear understanding of how and why your campaigns are performing. Your dashboard is a quick snapshot of your total Funds raised and where the support is coming from."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg pb-8" },
	            "All in one place. Straightforward and updated in real time."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center mx-auto px-4 py-8 md:p-8 w-full lg:hidden md:hidden mt-8 relative" },
	          _react2.default.createElement(
	            "div",
	            { className: "", style: { height: "450" } },
	            _react2.default.createElement("img", { src: _Donor_Macbook2.default, className: "mt-18 mb-8 relative donor-profile-laptop", style: { top: "-120px", height: "350px", maxWidth: "500px", left: "-10px" } }),
	            _react2.default.createElement("img", { src: _Landing_Illustration6.default, className: "w-48 mt-18 mb-8 relative donor-profile-illustration", style: { top: "-225px", left: "55px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: "float-right w-3/4 pull-up" },
	              _react2.default.createElement(
	                "p",
	                { className: "text-purple-light text-xl mx-4 leading-normal relative text-right mt-8" },
	                "\"Now I'm able to really understand our supporters and establish long-lasting connections\""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text-white mobile-yellow px-8 mx-auto py-12 text-center relative lg:hidden md:hidden", style: {} },
	          _react2.default.createElement(
	            "h3",
	            { className: "capitalize pt-8" },
	            "Donor profile"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg" },
	            "We make conversations possible between you and your supporters."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "mb-4 mt-4 leading-loose text-lg" },
	            "Send thank you messages, create tags and notes, and get full insight into giving history. We make it easy for you to really get to know your donors and build lasting relationships."
	          )
	        )
	      );
	    }
	
	    if (this.state.featuredItem === 'dashboard') {
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex featured-box", style: { marginTop: "-260px" } },
	          _react2.default.createElement(
	            "div",
	            { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "my-8", style: { height: "250px" } },
	              _react2.default.createElement("img", { src: _Landing_Illustration4.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64 md:mx-auto", style: { top: "-200px", left: "70px" } }),
	              _react2.default.createElement(
	                "p",
	                { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                "\"The beauty of it is that's all in one place!\""
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "text-white bg-orange px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	              _react2.default.createElement(
	                "h3",
	                { className: "capitalize" },
	                "Charity Dashboard"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "mb-4 mt-4 leading-loose text-lg" },
	                "Get a clear understanding of how and why your campaigns are performing. Your dashboard is a quick snapshot of your total Funds raised and where the support is coming from."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "mb-4 mt-4 leading-loose text-lg" },
	                "All in one place. Straightforward and updated in real time."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "w-2/3 relative md:w-2/5" },
	            _react2.default.createElement(
	              "div",
	              { className: "relative", style: { height: "585px" } },
	              _react2.default.createElement("img", { src: _Stats_laptop2.default, className: "mt-18 mb-8 absolute donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px", zIndex: '10' } }),
	              _react2.default.createElement("img", { src: _Stats_laptop_b2.default, className: "mt-18 mb-8 absolute donor-profile-laptop stats-2", style: { top: "30px", height: "450px", maxWidth: "1000px", right: "-300px" } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	              _react2.default.createElement(
	                "div",
	                { className: "flex flex-wrap flex-auto self-center" },
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                    return _this2.updateState("design");
	                  } }),
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-orange" }),
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                    return _this2.updateState("profile");
	                  } })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "w-64 md:hidden" },
	                _react2.default.createElement(
	                  "button",
	                  { className: "flex-none w-2/3 ml-16 text-purple border border-purple text font-bold py-2 px-8 rounded-full capitalize mt-8 mb-4 focus:outline-none focus:shadow-outline float-right", onClick: function onClick() {
	                      return _this2.updateState("profile");
	                    } },
	                  "Next"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple font-bold text-right w-full leading-loose" },
	                  "Build strong relationships",
	                  _react2.default.createElement("br", null),
	                  "with your supporters"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    if (this.state.featuredItem === 'profile') {
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex featured-box", style: { marginTop: "-260px" } },
	          _react2.default.createElement(
	            "div",
	            { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "my-8", style: { height: "250px" } },
	              _react2.default.createElement("img", { src: _Landing_Illustration6.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64", style: { top: "-200px", left: "80px" } }),
	              _react2.default.createElement(
	                "p",
	                { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                "\"Now I'm able to really understand our supporters and establish long-lasting connections\""
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "text-white bg-yellow px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	              _react2.default.createElement(
	                "h3",
	                { className: "capitalize" },
	                "Donor profile"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "mb-4 mt-4 leading-loose text-lg" },
	                "We make conversations possible between you and your supporters."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "mb-4 mt-4 leading-loose text-lg" },
	                "Send thank you messages, create tags and notes, and get full insight into giving history. We make it easy for you to really get to know your donors and build lasting relationships."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "w-2/3 md:w-2/5" },
	            _react2.default.createElement("img", { src: _Donor_Macbook2.default, className: "mt-18 mb-8 relative donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	              _react2.default.createElement(
	                "div",
	                { className: "flex flex-wrap flex-auto self-center" },
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                    return _this2.updateState("design");
	                  } }),
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                    return _this2.updateState("dashboard");
	                  } }),
	                _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-yellow" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "w-64 md:hidden" },
	                _react2.default.createElement(
	                  "button",
	                  { className: "flex-none w-2/3 ml-16 text-purple border border-purple text font-bold py-2 px-8 rounded-full capitalize mt-8 mb-4 focus:outline-none focus:shadow-outline float-right", onClick: function onClick() {
	                      return _this2.updateState("design");
	                    } },
	                  "Next"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple font-bold text-right w-full leading-loose" },
	                  "Get your online",
	                  _react2.default.createElement("br", null),
	                  "fundraising up and running"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  };
	
	  return InfoSection;
	}(_react.Component);
	
	exports.default = InfoSection;
	module.exports = exports["default"];

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSwipeable = __webpack_require__(144);
	
	var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);
	
	var _Davos_logo = __webpack_require__(12);
	
	var _Davos_logo2 = _interopRequireDefault(_Davos_logo);
	
	var _Davos_slogan = __webpack_require__(14);
	
	var _Davos_slogan2 = _interopRequireDefault(_Davos_slogan);
	
	var _facebook = __webpack_require__(15);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(17);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _instagram = __webpack_require__(16);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _Landing_Illustration = __webpack_require__(31);
	
	var _Landing_Illustration2 = _interopRequireDefault(_Landing_Illustration);
	
	var _Landing_Illustration3 = __webpack_require__(60);
	
	var _Landing_Illustration4 = _interopRequireDefault(_Landing_Illustration3);
	
	var _Landing_Illustration5 = __webpack_require__(61);
	
	var _Landing_Illustration6 = _interopRequireDefault(_Landing_Illustration5);
	
	var _builder_laptop = __webpack_require__(65);
	
	var _builder_laptop2 = _interopRequireDefault(_builder_laptop);
	
	var _Donor_Macbook = __webpack_require__(59);
	
	var _Donor_Macbook2 = _interopRequireDefault(_Donor_Macbook);
	
	var _Stats_laptop = __webpack_require__(62);
	
	var _Stats_laptop2 = _interopRequireDefault(_Stats_laptop);
	
	var _Stats_laptop_b = __webpack_require__(63);
	
	var _Stats_laptop_b2 = _interopRequireDefault(_Stats_laptop_b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Carousel = function (_Component) {
	  _inherits(Carousel, _Component);
	
	  function Carousel(props) {
	    _classCallCheck(this, Carousel);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      featuredItem: 'design'
	    };
	
	    _this.setDesign = _this.setDesign.bind(_this);
	    _this.setProfile = _this.setProfile.bind(_this);
	    _this.setDashboard = _this.setDashboard.bind(_this);
	    return _this;
	  }
	
	  Carousel.prototype.setDesign = function setDesign() {
	    this.setState({
	      featuredItem: 'design'
	    });
	  };
	
	  Carousel.prototype.setProfile = function setProfile() {
	    this.setState({
	      featuredItem: 'profile'
	    });
	  };
	
	  Carousel.prototype.setDashboard = function setDashboard() {
	    this.setState({
	      featuredItem: 'dashboard'
	    });
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.state.featuredItem === 'design') {
	      return _react2.default.createElement(
	        _reactSwipeable2.default,
	        { onSwipedRight: this.setProfile, onSwipedLeft: this.setDashboard },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden lg:hidden" },
	          _react2.default.createElement(
	            "div",
	            { className: "flex featured-box", style: { marginTop: "-260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	              _react2.default.createElement(
	                "div",
	                { className: "my-8", style: { height: "250px" } },
	                _react2.default.createElement("img", { src: _Landing_Illustration2.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64", style: { top: "-200px", left: "25%" } }),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                  "\"No more countless hours trying to set up a donation form that looks like our website\""
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "text-white bg-teal px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "capitalize" },
	                  "Donation campaign builder"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Quickly design your campaign using our modern templates. Decide on the fonts, colour, images, content and gift ranges that best suit your needs."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Want to personalize even further or create your own template? You are always in control with our advanced settings."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-2/3 md:w-2/5" },
	              _react2.default.createElement("img", { src: _builder_laptop2.default, className: "mt-18 mb-8 relative donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "flex flex-wrap flex-auto self-center" },
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-teal" }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setDashboard();
	                    } }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setProfile();
	                    } })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    if (this.state.featuredItem === 'dashboard') {
	      return _react2.default.createElement(
	        _reactSwipeable2.default,
	        { onSwipedRight: this.setDesign, onSwipedLeft: this.setProfile },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden lg:hidden", style: { position: "relative", zIndex: "50" } },
	          _react2.default.createElement(
	            "div",
	            { className: "flex featured-box", style: { marginTop: "-260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	              _react2.default.createElement(
	                "div",
	                { className: "my-8", style: { height: "250px" } },
	                _react2.default.createElement("img", { src: _Landing_Illustration4.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64 md:mx-auto", style: { top: "-200px", left: "70px" } }),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                  "\"The beauty of it is that's all in one place!\""
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "text-white bg-orange px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "capitalize" },
	                  "Charity Dashboard"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Get a clear understanding of how and why your campaigns are performing. Your dashboard is a quick snapshot of your total Funds raised and where the support is coming from."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "All in one place. Straightforward and updated in real time."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-2/3 relative md:w-2/5" },
	              _react2.default.createElement(
	                "div",
	                { className: "relative", style: { height: "585px" } },
	                _react2.default.createElement("img", { src: _Stats_laptop2.default, className: "mt-18 mb-8 absolute donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px", zIndex: '10' } }),
	                _react2.default.createElement("img", { src: _Stats_laptop_b2.default, className: "mt-18 mb-8 absolute donor-profile-laptop stats-2", style: { top: "30px", height: "450px", maxWidth: "1000px", right: "-300px" } })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "flex flex-wrap flex-auto self-center" },
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setDesign();
	                    } }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-orange" }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setProfile();
	                    } })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    if (this.state.featuredItem === 'profile') {
	      return _react2.default.createElement(
	        _reactSwipeable2.default,
	        { onSwipedRight: this.setDashboard, onSwipedLeft: this.setDesign },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 md:p-8 w-full sm:hidden" },
	          _react2.default.createElement(
	            "div",
	            { className: "flex featured-box", style: { marginTop: "-260px" } },
	            _react2.default.createElement(
	              "div",
	              { className: "w-1/3 mt-8 shadow-lg rounded-lg bg-white md:w-3/5", style: { height: "80%" } },
	              _react2.default.createElement(
	                "div",
	                { className: "my-8", style: { height: "250px" } },
	                _react2.default.createElement("img", { src: _Landing_Illustration6.default, className: "w-80 mt-18 mb-8 relative donor-profile-illustration md:w-64", style: { top: "-200px", left: "80px" } }),
	                _react2.default.createElement(
	                  "p",
	                  { className: "text-purple-light text-xl w-2/3 text-center leading-normal mx-auto relative", style: { top: "-200px" } },
	                  "\"Now I'm able to really understand our supporters and establish long-lasting connections\""
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "text-white bg-yellow px-12 mx-auto py-12 rounded-b-lg md:-mt-12" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "capitalize" },
	                  "Donor profile"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "We make conversations possible between you and your supporters."
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "mb-4 mt-4 leading-loose text-lg" },
	                  "Send thank you messages, create tags and notes, and get full insight into giving history. We make it easy for you to really get to know your donors and build lasting relationships."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-2/3 md:w-2/5" },
	              _react2.default.createElement("img", { src: _Donor_Macbook2.default, className: "mt-18 mb-8 relative donor-profile-laptop md:mt-12 md:-ml-12", style: { top: "-40px", height: "550px", maxWidth: "1000px", left: "-40px" } }),
	              _react2.default.createElement(
	                "div",
	                { className: "flex content-between self-start relative mx-16 md:mt-8", style: { top: "-100px" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "flex flex-wrap flex-auto self-center" },
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setDesign();
	                    } }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-grey", onClick: function onClick() {
	                      return _this2.setDashboard();
	                    } }),
	                  _react2.default.createElement("span", { className: "rounded-full inline-block h-3 w-3 items-center mx-1 bg-yellow" })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  };
	
	  return Carousel;
	}(_react.Component);
	
	exports.default = Carousel;
	module.exports = exports["default"];

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Davos_logo = __webpack_require__(12);
	
	var _Davos_logo2 = _interopRequireDefault(_Davos_logo);
	
	var _Davos_slogan = __webpack_require__(14);
	
	var _Davos_slogan2 = _interopRequireDefault(_Davos_slogan);
	
	var _facebook = __webpack_require__(15);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(17);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _instagram = __webpack_require__(16);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _maple_leafRed = __webpack_require__(66);
	
	var _maple_leafRed2 = _interopRequireDefault(_maple_leafRed);
	
	var _VentureConnection_LOGO = __webpack_require__(64);
	
	var _VentureConnection_LOGO2 = _interopRequireDefault(_VentureConnection_LOGO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "div",
	    { className: "" },
	    _react2.default.createElement(
	      "div",
	      { className: "py-5 footer-padded bg-purple-footer-image relative z-10" },
	      _react2.default.createElement(
	        "div",
	        { className: "max-w-3xl mx-auto p4 flex pt-15 sm:flex-wrap sm:flex-col md:flex-wrap md:flex-col" },
	        _react2.default.createElement(
	          "div",
	          { className: "w-1/3 text-white ml-4 mr-8 text-center text-xl mt-12 sm:w-full sm:mx-auto md:w-3/4 md:text-left md:mx-auto md:pt-8" },
	          _react2.default.createElement(
	            "h1",
	            { className: "sm:text-2xl md:mb-8 md:pt-8" },
	            "Discover if Davos ",
	            _react2.default.createElement("br", null),
	            "is right for you!"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "w-1/3 mx-auto mt-2 pt-2 sm:w-full md:w-3/4 md:text-left md:mx-auto" },
	          _react2.default.createElement(
	            "p",
	            { className: "text-white text-lg leading-normal sm:text-center sm:px-8" },
	            "Request early access and get our latest updates and news before anyone else!"
	          ),
	          _react2.default.createElement(
	            "form",
	            { name: "sign up", method: "POST", action: "/success#submitted", className: "pt-6 pb-8 mb-4 sm:px-8 sm:mt-8", "data-netlify": "true", "data-netlify-honeypot": "bot-field" },
	            _react2.default.createElement("input", { type: "hidden", name: "bot-field" }),
	            _react2.default.createElement(
	              "div",
	              { className: "mb-4" },
	              _react2.default.createElement("input", { className: "shadow appearance-none border rounded-full w-full py-2 px-4 text-purple-dark leading-tight focus:outline-none focus:shadow-outline", id: "name", type: "text", placeholder: "Name", name: "name" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mb-4" },
	              _react2.default.createElement("input", { className: "shadow appearance-none border rounded-full w-full py-2 px-4 text-purple-dark leading-tight focus:outline-none focus:shadow-outline", id: "email", type: "text", placeholder: "Email Address", name: "email" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "w-full" },
	              _react2.default.createElement(
	                "button",
	                { className: "w-full rounded-full bg-purple-light uppercase text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline tracking-wide", type: "submit" },
	                "Request early access"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "sm:text-center lg:pb-8 lg:pt-8 bg-purple-darkest relative footer" },
	      _react2.default.createElement(
	        "div",
	        { className: "flex justify-between items-end max-w-3xl mx-auto p-4 md:pl-8 text-sm sm:flex-wrap sm:flex-col md:items-right" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-white leading-normal w-1/3 sm:w-full sm:leading-loose md:w-1/2 md:ml-8 sm:pb-8" },
	          _react2.default.createElement("img", { src: _maple_leafRed2.default, className: "w-6 mb-4" }),
	          _react2.default.createElement(
	            "p",
	            { className: "leading-loose w-4/5 sm:w-full" },
	            "A proudly Canadian Startup currently working with SFU's Coast Capital Savings Venture Connection."
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "http://www.sfu.ca/io/venture/venture-connection.html", target: "_blank" },
	            _react2.default.createElement("img", { src: _VentureConnection_LOGO2.default, className: "w-4/5" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "pb-8" },
	          _react2.default.createElement(
	            "div",
	            { className: "flex items-center mb-6" },
	            _react2.default.createElement("img", { src: _Davos_logo2.default, className: "w-48 mr-8 md:w-32" }),
	            _react2.default.createElement("img", { src: _Davos_slogan2.default, className: "w-1/3" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "flex items-center sm:flex-wrap sm:flex-col md:w-3/4" },
	            _react2.default.createElement(
	              "p",
	              { className: "text-white flex-1 sm:mb-4" },
	              "Contact Us! ",
	              _react2.default.createElement(
	                "a",
	                { className: "text-white no-underline font-bold", href: "mailto:info@davos.gives" },
	                "info@davos.gives"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex flex-wrap flex-1 sm:justify-center sm:mb-8 md:justify-end" },
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center mr-3" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.facebook.com/davos.gives/", target: "_blank" },
	                  _react2.default.createElement("img", { src: _facebook2.default, className: "w-4 pt-1" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center mr-3" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://twitter.com/Davos_Gives", target: "_blank" },
	                  _react2.default.createElement("img", { src: _twitter2.default, className: "w-4 pt-1" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white text-white rounded-full h-8 w-8 flex items-center justify-center" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.instagram.com/davos.gives/", target: "_blank" },
	                  _react2.default.createElement("img", { src: _instagram2.default, className: "w-4 pt-1" })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Davos_logo.32d9a3c1.svg";

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Davos_slogan.ae527489.svg";

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Donor_Macbook.65939187.png";

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Landing_Illustration-03.5af7e37e.png";

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Landing_Illustration-04.4a8607a1.png";

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Landing_Illustration-05.72126117.png";

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Stats_laptop.2206b9e3.png";

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Stats_laptop_b.d3c3d50e.png";

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VentureConnection_LOGO.e3dee0b0.png";

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/builder_laptop.3e5cb58d.png";

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA1CAYAAAD/L5PDAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAABENJREFUaIHtmltvG0UUx3+zl9nZ9TXBcds0NKJQRKDigVSUIl5oX+gHgC+IeOOhD6g8cVFVCYEKQlyiSA0qdeIQJ66TOI4ve+UhOJWbqrbX2ZQ4/kv7YM/sOeevMzPnsiOiKIo4I9BetgEnCeMklUVRRBiGeJ5Hu92m0+ngeR6e5xEEAWEYEkURURQhhABACHH4KKXIZrMopTAMA00bzlfiJJdxEAR4nsfu7i6VSoWtrS3KSzrVv3I0Kzn8epqgZR+SFaaHZvhoqoMmPS59WOLarSKzs7M4joOUcij9J+LZIAhwXZdGo0GtVmNzc5OVBxHln16jtXKZcH8wOSu1PG8sLlMoFFBKDW3HiZB1XZednR1WV1f54UudzXsfENbNoeUEtWl83ycMw1h2JEo2DEOCIKBer1Mqlfj5bsTGV+/Hl9ciNlFImGwQBDSbTSqVCvc/t6l++26S6voi0dDjui61Wo211Q2q349OVIzomkTJtlotyuUyS1+fh/irrwfdkBQHiSzjbjRrt9s8/tNj+8HCUO9rKRCqdfDD8A4JnruxTD6fR0o5dIyFhPes67ps/P7KwCdv/qMl3vu0TKFQQEqJruvAU28qVSSXy+E4DoYxvOmJkvV9n8ZaYaC5uevLLH62zpUrb1IsFnvIHhcS27Pd1NCvZwaa/9btNebn50dapv2QeJyNvP4qhISZizbT09MopY7do10k6tlB025hgmEasZL7YZB4iTeIZwE0TUPTNYgfWfrrSE70/w8TsuOKWKdxEAT4vk+z2WR3d5d2u90z3j2cHv9dJqy/01deuA+P/thD1x9iSevIaazrOlJKHMchm81iWVYcs+N1KjqdDo1Gg1KpxL0vQrZ+fPu584In9lBytRSgewjT7/lfFqsUrpa5estlYWGBmZmZYU0GYno2DMPDgnzj7sexFD9X7j6A+d/zFK0nr/LPdp65xe/wPC+2/FOzZ2VxC8dxRko4Tg1Zp9DAtu2zQTZ9fv/skM2c66Ds0fLmU0M2O+OjlDpIKWMi1puapmEYBul0mtz15djKB0Xm2kMKF9KknBSGHr9QixVnfd+n3W6zvb1NuVxmb2+vZzyKIgJfsHI/x/qdwVqnhZu/MX+jipP3MWVvNZDJZJibm2NqegpLWrG6FBAzzmqahpSSfD6PaZq4rtsz3s2glP2I9TuDyVy4vcHl1y9hWUczKMuySKfTKEuNVALGIiuEwDAMhBCYpnmkcd3tUtRqNbQUfT9vCAm5fOqweH/Wc91tM2qtG5usEAJN0zDNo820LlnLskD3eDYjOiLPBGlJbMdGKYVpDP9pZBCcmtP4ODAhO66YkB1XTMiOKyZkxxUTsuOKCdlxxYTsuGJCdlyR6J0Kx3G4+MkvrH/z4tttF27+SiYzha7rI13q6odE7ht3RTabTarVKq1W64XzbdtmanoKx3EOrhuIZBbciV6uftn4FyZTllUzR6hgAAAAAElFTkSuQmCC"

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/girl_with_dog.76fd5131.png";

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0NS45IDU4LjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ1LjkgNTguNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNjZTJlNDg7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDEuNywxNi45bC01LjgsMmwwLTAuOWMwLTEuNy0yLjEtMi43LTMuNC0xLjZsLTQuMSw0LjdsMy0xMS40YzAuMi0xLjctMS44LTIuOS0zLjMtMS45bC0wLjgsMC41bC0xLjctNS44CgljLTAuNi0xLTItMS4yLTIuOC0wLjNsLTMsNS41bC0xLjUtMS4yYy0xLjYtMS4zLTMuOSwwLTMuNywyTDE2LjEsMjBsLTMuMS0zLjNjLTEuNC0xLjEtMy40LTAuMS0zLjQsMS43bDAsMC45bC01LjgtMS44CgljLTEuMi0wLjEtMi4xLDEtMS43LDIuMWwzLjEsNS41bC0xLjksMC42QzEuNCwyNi40LDEuMiwyOSwzLDI5LjlsOS4zLDQuNUwxMC44LDM4Yy0wLjUsMS4yLDAuNSwyLjUsMS44LDIuM2w5LTEuMwoJYzAuMSw1LjYsMC4zLDExLjMsMC43LDE2LjljMC4xLDEuMiwxLjksMS4xLDEuOCwwYy0wLjQtNS42LTAuNi0xMS4yLTAuNy0xNi45bDguOCwwLjljMS4zLDAuMSwyLjMtMS4yLDEuOC0yLjRsLTEuMi0yLjlMNDMsMjkuMwoJYzEuOC0wLjksMS41LTMuNi0wLjQtNC4ybC0xLjktMC41bDIuOS01LjZDNDMuOCwxNy44LDQyLjgsMTYuOCw0MS43LDE2Ljl6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Davos_sloganRed = __webpack_require__(88);
	
	var _Davos_sloganRed2 = _interopRequireDefault(_Davos_sloganRed);
	
	var _campaignBuilder = __webpack_require__(90);
	
	var _campaignBuilder2 = _interopRequireDefault(_campaignBuilder);
	
	var _girl_with_dog = __webpack_require__(146);
	
	var _girl_with_dog2 = _interopRequireDefault(_girl_with_dog);
	
	var _Footer = __webpack_require__(92);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "pull-up" },
	      _react2.default.createElement(
	        "div",
	        { className: "flex flex-col flex-1 md:justify-center max-w-3xl mx-auto px-4 py-8 sm:py-0 md:p-8 sm:px-0 w-full top-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-wrap sm:flex-col-reverse sm:flex-col md:flex-col md:flex-col-reverse" },
	          _react2.default.createElement(
	            "div",
	            { className: "w-1/3 sm:w-full text-grey-dark pr-8 sm:px-8 sm:text-sm sm:text-center md:mx-auto md:w-2/3 md:text-center give-meaning" },
	            _react2.default.createElement(
	              "h1",
	              { className: "sm:m-auto sm:text-center md:text-center" },
	              "We're here to"
	            ),
	            _react2.default.createElement("img", { src: _Davos_sloganRed2.default, className: "w-64 sm:w-48 mt-3 mb-8 ml-1 sm:m-auto sm:mb-0 sm:mt-2 md:mx-auto" }),
	            _react2.default.createElement(
	              "p",
	              { className: "mb-4 leading-normal mt-8 text-lg sm:text-left md:text-left" },
	              "We believe online fundraising should be a walk in the park, where charities and donors can build lasting relationships."
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "mb leading-normal text-lg sm:text-left sm:mb-8 md:text-left" },
	              _react2.default.createElement(
	                "span",
	                { className: "text-purple" },
	                "Davos"
	              ),
	              " empowers you to keep on giving meaning. Expand your audience online and fuel the work that transforms your community."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "w-2/3 sm:w-full md:mx-auto" },
	            _react2.default.createElement("img", { src: _girl_with_dog2.default, className: "relative human-picture md:ml-8", style: { top: "-300px", left: "-50px" } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "featured-item sm:mt-8" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-purple-dark relative sm:text-center sm:mx-auto sm:w-3/4 sm:leading-normal easy-peasy" },
	          _react2.default.createElement(
	            "h1",
	            { className: "text-5xl text-center mb-3 sm:text-xl sm:", id: "more-info" },
	            "It's Easy Peasy"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "text-xl text-center" },
	            "for charities like the Barks & Meows Shelter"
	          )
	        ),
	        _react2.default.createElement(_campaignBuilder2.default, null)
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9394f65045351fd4293d.js